import moment from 'moment';

export default function isNotAPastEvent(dates, publishDate) {
  const today = moment();

  if (dates === null || dates === undefined) {
    if (publishDate) {
      return moment(publishDate, 'MM-DD-YYYY').isBefore(today) === false;
    }
    return true;
  }

  return dates.some(({ date, hour }) => {
    return moment(`${date} ${hour}`, 'MM-DD-YYYY H:m:s').isSameOrAfter(today);
  });
}
